// chatConstants.js
export const CHAT_TYPES = {
  TEACHER: 'teacher',
  STUDENT: 'student',
  GROUP: 'group'
};

export const FILTER_OPTIONS = [
  { label: 'All Chats', value: 'all' },
  { label: 'Teachers', value: 'teachers' },
  { label: 'Students', value: 'students' },
  { label: 'Groups', value: 'groups' },
];

export const CHAT_ACTIONS_MENU_ITEMS = [
  {
    label: 'Chat Actions',
    items: [
      { label: 'View Profile', icon: 'pi pi-user' },
      { label: 'Media & Files', icon: 'pi pi-images' },
      { label: 'Search in Chat', icon: 'pi pi-search' },
      { label: 'Mute Notifications', icon: 'pi pi-bell' },
      { label: 'Clear Chat', icon: 'pi pi-trash', className: 'text-red-500' },
    ]
  }
];

// Sample data arrays
export const teachersData = [
  { id: 1, name: 'Ms. Priya (Science)', lastMessage: 'Don\'t forget to submit your lab reports', time: '10:57 AM', unread: 0, avatar: './teacher1.png', type: 'teacher', subject: 'Science' },
  { id: 2, name: 'Mr. Raju (Class Teacher)', lastMessage: 'Parent-teacher meeting this Friday', time: '10:26 AM', unread: 3, avatar: './teacher2.png', type: 'teacher', subject: 'Mathematics' },
  { id: 3, name: 'Mrs. Mahesh (English)', lastMessage: 'Great essay! Keep it up', time: '09:15 AM', unread: 1, avatar: './teacher3.png', type: 'teacher', subject: 'English' },
];

export const studentsData = [
  { id: 101, name: 'Rahul Sharma', lastMessage: 'I have a doubt in problem 5', time: '11:30 AM', unread: 0, avatar: './student1.png', type: 'student', grade: '6-A' },
  { id: 102, name: 'Priya Patel', lastMessage: 'Thank you for the notes ma\'am', time: '11:15 AM', unread: 2, avatar: './student2.png', type: 'student', grade: '6-A' },
  { id: 103, name: 'Amit Kumar', lastMessage: 'When is the next test?', time: '10:45 AM', unread: 0, avatar: './student3.png', type: 'student', grade: '6-B' },
];

export const groupsData = [
  { id: 201, name: '6-A Class Group', lastMessage: 'Rahul: Homework uploaded in portal', time: '10:57 AM', unread: 5, avatar: './group1.png', type: 'group', members: 35 },
  { id: 202, name: 'Science Project Team', lastMessage: 'Priya: Meeting at 3 PM today', time: '09:30 AM', unread: 12, avatar: './group2.png', type: 'group', members: 8 },
  { id: 203, name: 'Math Olympiad Prep', lastMessage: 'Mr. Raju: Practice problems shared', time: 'Yesterday', unread: 0, avatar: './group3.png', type: 'group', members: 15 },
];

// Sample messages data
export const sampleMessages = {
  'teacher-1': [
    { id: 1, text: 'Don\'t forget to submit your lab reports', time: '10:57 AM', sender: 'them', read: true },
    { id: 2, text: 'I will submit by tomorrow', time: '11:00 AM', sender: 'you', read: true },
  ],
  'teacher-2': [
    { id: 1, text: 'Parent-teacher meeting this Friday', time: '10:26 AM', sender: 'them', read: true },
    { id: 2, text: 'Looking forward to it!', time: '10:30 AM', sender: 'you', read: true },
  ],
  'teacher-3': [
    { id: 1, text: 'Great essay! Keep it up', time: '09:15 AM', sender: 'them', read: true },
    { id: 2, text: 'Thank you ma\'am!', time: '09:20 AM', sender: 'you', read: true },
  ],
  'student-101': [
    { id: 1, text: 'I have a doubt in problem 5', time: '11:30 AM', sender: 'them', read: true },
    { id: 2, text: 'Can you explain it again?', time: '11:35 AM', sender: 'you', read: true },
    { id: 3, text: 'I have a doubt in problem 5', time: '11:30 AM', sender: 'them', read: true },
    { id: 4, text: 'Can you explain it again?', time: '11:35 AM', sender: 'you', read: true },
    { id: 5, text: 'I have a doubt in problem 5', time: '11:30 AM', sender: 'them', read: true },
    { id: 6, text: 'Can you explain it again?', time: '11:35 AM', sender: 'you', read: true },
  ],
  'student-102': [
    { id: 1, text: 'Thank you for the notes ma\'am', time: '11:15 AM', sender: 'them', read: true },
    { id: 2, text: 'You\'re welcome!', time: '11:20 AM', sender: 'you', read: true },
  ],
  'student-103': [
    { id: 1, text: 'When is the next test?', time: '10:45 AM', sender: 'them', read: true },
    { id: 2, text: 'Next Monday', time: '10:50 AM', sender: 'you', read: true },
  ],
  'group-201': [
    { id: 1, text: 'Homework uploaded in portal', time: '10:57 AM', sender: 'Rahul', read: true },
    { id: 2, text: 'Thanks for the update!', time: '11:00 AM', sender: 'you', read: true },
  ],
  'group-202': [
    { id: 1, text: 'Meeting at 3 PM today', time: '09:30 AM', sender: 'Priya', read: true },
    { id: 2, text: 'I\'ll be there', time: '09:35 AM', sender: 'you', read: true },
  ],
  'group-203': [
    { id: 1, text: 'Practice problems shared', time: 'Yesterday', sender: 'Mr. Raju', read: true },
    { id: 2, text: 'Working on them now', time: 'Today', sender: 'you', read: true },
  ],
};